import { render, staticRenderFns } from "./SpeciesEdit.vue?vue&type=template&id=218841ec&scoped=true&"
import script from "./SpeciesEdit.vue?vue&type=script&lang=js&"
export * from "./SpeciesEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesEdit.vue?vue&type=style&index=0&id=218841ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218841ec",
  null
  
)

export default component.exports